export const FORM_CLEAR_ERROR = 'FORM_CLEAR_ERROR';
export const FORM_REQUEST = 'FORM_REQUEST';
export const FORM_SUCCESS = 'FORM_SUCCESS';
export const FORM_FAILURE = 'FORM_FAILURE';
export const FORM_SAVE = 'FORM_SAVE';
export const FORM_RESET = 'FORM_RESET';
